import Page from './page';
import MessageHelper from '../helpers/message-helper';

interface FormInputData {
    name: string,
    value: string | number | boolean,
    type: string,
    required?: boolean
}

export default class CustomerAdminPage extends Page {

    constructor(private body: HTMLBodyElement) {
        super();
        this.bindOrderFunctionToggle();
        this.bindOnlyCustomerPricesFunctionToggle();
    }

    bindOrderFunctionToggle(): void {
        $(this.body).on('submit', '.order-function-toggle', (e) => {
            e.preventDefault();
            e.stopPropagation();

            let isEnabling: boolean;
            const form = $(e.target);

            form.ajaxSubmit({
                url: `${form.attr('action') as string}`,
                beforeSubmit: (formData: FormInputData[]): boolean => {
                    isEnabling = true;

                    if (!formData.find((data) => data.name === 'allowToOrder')) {
                        isEnabling = false;

                        formData.push({
                            name: 'allowToOrder',
                            value: 'false',
                            type: 'hidden',
                            required: false
                        });
                    }

                    return true;
                },
                success() {
                    form.find('.js-toggleText').text(MessageHelper.getMessage(isEnabling ? 'eparts.customer.admin.order.enabled' : 'eparts.customer.admin.order.disabled'));
                },
                error() {
                    window.NotificationHelper.showError(MessageHelper.getMessage('common.error.occurred'));
                }
            });

            return false;
        });
    }

    bindOnlyCustomerPricesFunctionToggle(): void {
        $(this.body).on('submit', '.only-customer-prices-function-toggle', (e) => {
            e.preventDefault();
            e.stopPropagation();

            let isEnabling: boolean;
            const form = $(e.target);

            form.ajaxSubmit({
                url: `${form.attr('action') as string}`,
                beforeSubmit: (formData: FormInputData[]): boolean => {
                    isEnabling = true;

                    if (!formData.find((data) => data.name === 'onlyCustomerPrices')) {
                        isEnabling = false;

                        formData.push({
                            name: 'onlyCustomerPrices',
                            value: 'false',
                            type: 'hidden',
                            required: false
                        });
                    }

                    return true;
                },
                success() {
                    form.find('.js-toggleText').text(MessageHelper.getMessage(isEnabling ? 'eparts.customer.admin.order.enabled' : 'eparts.customer.admin.order.disabled'));
                },
                error() {
                    window.NotificationHelper.showError(MessageHelper.getMessage('common.error.occurred'));
                }
            });

            return false;
        });
    }

}
